import { openDB } from 'idb';

const STORE_NAME = 'pendingNews';
const DB_VERSION = 1;

function getDbName() {
    return 'offline_queue_' + localStorage.getItem('schoolName');
}

function getDb() {
    return openDB(getDbName(), DB_VERSION, {
        upgrade(db) {
            db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
        },
    });
}

export async function addPendingNews(payload) {
    const db = await getDb();
    return db.add(STORE_NAME, { payload, createdAt: Date.now() });
}

export async function getAllPendingNews() {
    const db = await getDb();
    return db.getAll(STORE_NAME);
}

export async function deletePendingNews(id) {
    const db = await getDb();
    return db.delete(STORE_NAME, id);
}

export async function countPendingNews() {
    const db = await getDb();
    return db.count(STORE_NAME);
}
